import styled from 'styled-components';

const Container = styled.div`
    margin: 40px 0;
`;

const Date = styled.div`
    text-transform: uppercase;
    letter-spacing: 1px;
`;

const Title = styled.div`
    margin-top: 10px;

    & > h3 {
        line-height: 1.2;
    }

    @media screen and (max-width: ${props => props.theme.breakpoints && props.theme.breakpoints.sm}){
        & > h3 {
           font-size: 37px;
        }
    }
`;

const Author = styled.div`
    display: flex;
`;

const AuthorImgContainer = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
`;

const AuthorImg = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 44px;
    height: 44px;
    border-radius: 50%;
    background-image: ${props => props.backgroundImage};
    background-position: center;
    background-size: cover;
    background-color: #000;
`;

const FirstLetter = styled.span`
    font-size: 28px;
    font-weight: bold;
    color: #fff;
`;

const AuthorInfo = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    margin-left: 1rem;
`;

const AuthorName = styled.div`
    display: inline;
    border-bottom: solid 2px #001eff;
`;

const AuthorTitle = styled.div`
    opacity: .7;
`;



export { Container, Date, Title, Author, AuthorImgContainer, AuthorImg, FirstLetter, AuthorInfo, AuthorName, AuthorTitle };